import TranslationsComponent from './Translations.vue';

export const translationsRoutes = {
  path: '/translations/:documentId?',
  name: 'My translations',
  component: TranslationsComponent,
  meta: {
    title: 'Translations',
    requireAuth: true,
    defaultPath: '/translations'
  },
  props: true
};
